import { AcornsIcon } from '@acorns/icons'
import { Heading } from '@acorns/web-components'
import { Image } from '@acorns/web-components'
import styled from 'styled-components'

import checkmark from 'assets/icons/green_check.svg'
import Button from 'components/Button'
import { CTAContainer } from 'components/CTAContainer'
import Layout from 'components/Layout'
import theme from 'theme'
import { style } from 'theme'

import checked from './assets/checked.svg'

export const StyledButton = styled(Button)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 24px 10px;
  width: 220px;

  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    height: 44px;
    width: 100%;
  }
`

export const TopActionWrapper = styled.div`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${theme.colors.white} 9.58%);
    top: 50px;
    height: 65px;
    overflow: hidden;
    align-items: center;
    padding-bottom: 30px;
    position: sticky;
    z-index: 9;
  }
`

export const ActionWrapper = styled(CTAContainer)`
  @media (max-width: ${style(theme => theme.breakpoints.sm)}px) {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${theme.colors.white} 9.58%);
  }
`

export const MOCLayout = styled(Layout)`
  position: relative;
  overflow: hidden;
  margin: auto;
  width: fit-content;

  @media (min-width: ${style(theme => theme.breakpoints.md)}px) {
    width: 708px;
    padding-top: 0;
  }
`

export const Divider = styled.div`
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    height: 10px;
    margin-top: 30px;
    background: ${theme.colors.ivory};
    border-top: 1px solid ${theme.colors.ivory};
    width: calc(100% + 60px);
    margin-left: -30px;
    margin-bottom: 10px;
  }
`

export const ItemDivider = styled.div`
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin-left: auto;
    width: 315px;
    background: ${theme.colors.ivory};
    height: 1px;
    margin-bottom: 0px;
    margin-top: 10px;
    z-index: 10;
  }
`

export const StyledHeading = styled(Heading)`
  font-size: 30px;
  line-height: 38px;
  letter-spacing: 0;
`

export const TierPriceContainer = styled.p`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 141px;
  height: 30px;
  margin-left: 2px;
  margin-bottom: 0px;
`

export const TierPriceText = styled.p`
  color: ${style(theme => theme.colors.stoneLight)};
  font-size: 22px;
  margin-top: 0;
  margin-right: 4px;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 0px;
  position: relative;
`
export const WaivedTierPriceText = styled.p`
  color: ${style(theme => theme.colors.green)};
  font-size: 22px;
  margin-top: 0;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 0px;
`

export const DirectDepositText = styled.p`
  color: ${style(theme => theme.colors.stone)};
  font-size: 12px;
  margin-top: 4px;
  font-weight: 400;
  margin-bottom: 0px;
`

export const TierDescriptionText = styled.p`
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 0;
  max-width: 400px;

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin-top: 12px;
  }
`

export const StyledContainer = styled.div`
  padding: 20px 186px 30px;

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    padding-left: 110px;
    padding-right: 110px;
  }

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    padding-right: 65px;
    padding-left: 0;
    padding-bottom: 10px;
    margin-top: -10px;
  }
`

export const ListHeading = styled(Heading)`
  font-size: 18px;
  line-height: 38px;
  padding-left: 12px;
`

export const ActionWrapperDivider = styled.div`
  @media screen and (min-width: ${theme.breakpoints.sm + 1}px) {
    margin-left: -50px;
    width: calc(100% + 100px);
    background: ${theme.colors.ivory};
    height: 1px;
    margin-bottom: 10px;
    margin-top: 18px;
  }
`

export const TierBenefitsContainer = styled.div`
  margin-bottom: 0px;
  padding-left: 186px;
  padding-right: 170px;

  @media screen and (max-width: ${theme.breakpoints.md}px) {
    padding-left: 110px;
    padding-right: 110px;
  }

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    padding-right: 0;
    padding-left: 0;
    margin-bottom: 0px;
  }
`

export const TierBenefitsList = styled.ul`
  padding-left: 18px;
  margin-top: 8px;
`

export const AccountTypesHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const TierBenefitsListItem = styled.li<{ available?: boolean }>`
  padding-bottom: 18px;
  padding-left: 15px;
  font-size: 14px;
  vertical-align: top;
  color: ${props => (props.available ? theme.colors.charcoal : theme.colors.stone)};
  list-style-image: url(${props => (props.available ? checkmark : checked)});

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    padding-bottom: 12px;
  }
`

export const TierBenefitTitle = styled.span`
  display: flex;
  margin-bottom: 4px;
`

export const BenefitIcon = styled(AcornsIcon)`
  width: 24px;
  height: 24px;
  margin-top: 5px;
`
export const TierPriceVector = styled.img`
  width: 32px;
  height: 20px;
  margin-right: 118px;
  position: absolute;
  z-index: 1;
`
export const WaivedTierPriceVector = styled.img`
  width: 38px;
  height: 20px;
  margin-top: 22px;
  margin-right: 44px;
  position: absolute;
  z-index: 1;
`
export const StyledImage = styled(Image)`
  position: absolute;
  top: 0;
  right: 0;
  width: 160px;
  border-top-right-radius: 12px;

  @media screen and (min-width: ${theme.breakpoints.sm + 1}px) and (max-width: ${theme.breakpoints
      .md}px) {
    right: 30px;
  }

  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    right: -10px;
    top: -4px;
    height: 160px;
    width: 160px;
    overflow: hidden;
    object-fit: contain;
    border-top-right-radius: 0px;
  }
`

export const HeaderRow = styled.div`
  display: flex;
  width: calc(100% + 30px);
`

export const SwitchContainer = styled.div`
  width: 340px;
  margin-left: 180px;

  @media screen and (min-width: ${theme.breakpoints.sm}px) {
    margin-top: 10px;
    margin-left: 180px;
    padding-top: 20px;
  }
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin: 10px auto 10px;
    padding-top: 0px;
  }
`

export const PrivacyPolicy = styled.div`
  font-size: 12px;
  font-style: italic;
  line-height: 16px;
  margin: 0px auto 40px;
  text-align: left;
  max-width: 340px;
  > a {
    text-decoration: underline;
  }
  color: ${style(theme => theme.colors.stone)};
  @media screen and (max-width: ${theme.breakpoints.sm}px) {
    margin-bottom: 118px;
  }
`
